module.exports = __webpack_public_path__ + "OpenSans-SemiboldItalic.da061416028fc9a66fbc.eot";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/SemiboldItalic/OpenSans-SemiboldItalic.eot
// module id = ../../../../npm-font-open-sans/fonts/SemiboldItalic/OpenSans-SemiboldItalic.eot
// module chunks = styles